import { render } from "./Step5.vue?vue&type=template&id=53e8c021"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"

import "./Step5.vue?vue&type=style&index=0&id=53e8c021&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__